/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
// import { DateRangePicker } from "react-dates";
// material
import { styled } from '@mui/material/styles';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Toolbar, Typography, OutlinedInput, InputAdornment, Button } from '@mui/material';
import { CSVLink } from 'react-csv';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from 'antd';
// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  selected: PropTypes.array,
  hideHeader: PropTypes.bool,
};

const { RangePicker } = DatePicker;

export default function UserListToolbar({ numSelected, filterName, onFilterName, selected, hideHeader }) {
  const navigate = useNavigate();

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search email..."
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        hideHeader ? (
          <Button variant="outlined" onClick={() => navigate('/dashboard/campaigns/campaigns/create')}>
            Finish
          </Button>
        ) : (
          <>
            <CSVLink data={selected} filename="leads.csv" style={{ textDecoration: 'none' }}>
              <Button variant="outlined" startIcon={<FileDownloadIcon />}>
                Download
              </Button>
            </CSVLink>
            <Button variant="outlined" onClick={() => navigate('/dashboard/campaigns/campaigns/create')}>
              Create Campaign
            </Button>
          </>
        )
      ) : (
        <RangePicker onChange={(dates, dateStrings) => console.log(dateStrings)} />
      )}
    </RootStyle>
  );
}
